module.exports = __webpack_public_path__ + "img/receipt_progress1.8b41b79b.png";